// extracted by mini-css-extract-plugin
export default {"apSamplePreviewOverride":"apSamplePreviewOverride__3rJ0f"};